export default __webpack_public_path__ + "static/media/ill-no-data.02c93060.svg";